import React from 'react';

function ProfilePage() {
  // Get user data
  const getUserData = () => {
    try {
      const userData = localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null;
    }
  };

  const user = getUserData();

  return (
    <div className="user-home-layout__page">
      <div className="user-home-layout__page-header">
        <h1 className="user-home-layout__page-title">Profile</h1>
        <p className="user-home-layout__page-subtitle">
          Manage your personal information
        </p>
      </div>

      <div className="user-home-layout__card">
        <h2 className="user-home-layout__card-title">User Information</h2>
        <div className="user-home-layout__profile-info">
          <div className="user-home-layout__profile-field">
            <label className="user-home-layout__profile-label">First Name</label>
            <div className="user-home-layout__profile-value">{user?.firstName || 'N/A'}</div>
          </div>
          <div className="user-home-layout__profile-field">
            <label className="user-home-layout__profile-label">Last Name</label>
            <div className="user-home-layout__profile-value">{user?.lastName || 'N/A'}</div>
          </div>
          <div className="user-home-layout__profile-field">
            <label className="user-home-layout__profile-label">Email</label>
            <div className="user-home-layout__profile-value">{user?.email || 'N/A'}</div>
          </div>
          <div className="user-home-layout__profile-field">
            <label className="user-home-layout__profile-label">User ID</label>
            <div className="user-home-layout__profile-value user-home-layout__profile-value--mono">{user?.userId || 'N/A'}</div>
          </div>
        </div>
        <div className="user-home-layout__badge user-home-layout__badge--info">
          Profile editing coming soon
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;



